<template>
  <button
    class="choice-button"
    :class="{
      'choice-button--selected': selected,
      'choice-button--compact': compact,
      'choice-button--with-image': choice.imageSrc,
    }"
    type="button"
    :disabled="disabled"
    @click="$emit('select')"
  >
    <div
      v-if="choice.imageSrc || choice.subtext"
      class="choice-button__visual"
    >
      <img
        v-if="choice.imageSrc"
        :src="choice.imageSrc"
        :alt="choice.imageAlt || ''"
        class="choice-button__image"
      />

      <span
        v-else-if="choice.subtext"
        class="choice-button__subtext"
      >
        {{ choice.subtext }}
      </span>
    </div>

    <span class="choice-button__text">
      {{ choice.text }}
    </span>

    <span
      v-if="selected"
      class="choice-button__check"
      aria-hidden="true"
    >
      ✓
    </span>
  </button>
</template>

<script setup lang="ts">
import type { Choice } from '@/types/content'

defineProps<{
  choice: Choice
  selected: boolean
  disabled?: boolean
  compact?: boolean
}>()

defineEmits<{
  select: []
}>()
</script>